import { render } from "./milestone-onboarding-dialog.vue?vue&type=template&id=1f3babd0&ts=true"
import script from "./milestone-onboarding-dialog.vue?vue&type=script&lang=ts"
export * from "./milestone-onboarding-dialog.vue?vue&type=script&lang=ts"

import "./milestone-onboarding-dialog.vue?vue&type=style&index=0&id=1f3babd0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__